import Vue from "vue";
import Router from "vue-router";
import clientRouter from './clientRouter'
import manageRouter from './manageRouter'

Vue.use(Router);

//import Layout from "@/layout";
const routes = [
  // 管理端
  manageRouter,
  // 客户端
  clientRouter,
  //单独得页面  不需要头部 菜单
  {
    path: "/Setup",
    component: () => import("@/page/setup"),
    hidden: true,
    meta: {
      title: "登录",
    },
  },

]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
